import React from "react";
import { useNavigate } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-container">
      <div className="notfound-card">
        <div className="notfound-code">404</div>
        <div className="notfound-divider" />
        <div className="notfound-content">
          <h1 className="notfound-title">Page Not Found</h1>
          <p className="notfound-message">
            The page you are looking for does not exist or may have been moved.
            Please check the URL or return to the home page.
          </p>
          <button
            className="notfound-btn"
            onClick={() => navigate("/")}
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
